import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

export default function Custom() {
  return (
    <div data-testid="custom-page" className="flex min-h-[85vh] flex-col justify-center px-5 pb-32 pt-36 md:px-16">
      <div className="mx-auto w-full max-w-[1500px]">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: EASE }}
          className="text-[10px] font-medium uppercase tracking-[0.5em] text-fog md:text-xs"
        >
          Custom
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.1, ease: EASE }}
          className="mt-6 max-w-5xl font-display text-5xl font-medium leading-[0.98] tracking-[-0.03em] md:text-8xl"
        >
          Built from zero, for you.
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.25, ease: EASE }}
          className="mt-8 max-w-xl text-base leading-relaxed text-fog md:text-lg"
        >
          When nothing in the library fits, we design and build the thing itself — website,
          application, tool, or system. Scoped individually. Quoted exactly. It starts with a
          guided intake, not a contact form.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.4, ease: EASE }}
        >
          <Link
            to="/start"
            data-testid="custom-start-link"
            className="group mt-10 inline-flex items-center gap-3 border border-white px-6 py-4 text-xs font-semibold uppercase tracking-[0.25em] transition-colors duration-500 ease-cinematic hover:bg-white hover:text-obsidian"
          >
            Start a Custom Project
            <ArrowUpRight className="h-4 w-4 transition-transform duration-500 ease-cinematic group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </motion.div>
      </div>
    </div>
  );
}
